var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrongCustomerAuthentication1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -64 512.00009 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#662d91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c9dd"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(1.08242 0 0 -1.08242 .000094 447.028302)",
    gradientUnits: "userSpaceOnUse",
    x1: 65.0396,
    x2: 390.2054,
    xlinkHref: "#a",
    y1: 411.0188,
    y2: 85.853
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1.08242 0 0 -1.08242 .000094 447.028302)",
    gradientUnits: "userSpaceOnUse",
    x1: 122.1954,
    x2: 447.3612,
    xlinkHref: "#a",
    y1: 468.1747,
    y2: 143.0089
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(1.08242 0 0 -1.08242 .000094 447.028302)",
    gradientUnits: "userSpaceOnUse",
    x1: 84.7005,
    x2: 409.8663,
    xlinkHref: "#a",
    y1: 430.6798,
    y2: 105.514
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientTransform: "matrix(1.08242 0 0 -1.08242 .000094 447.028302)",
    gradientUnits: "userSpaceOnUse",
    x1: 127.1748,
    x2: 452.3406,
    xlinkHref: "#a",
    y1: 473.154,
    y2: 147.9883
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientTransform: "matrix(1.08242 0 0 -1.08242 .000094 447.028302)",
    gradientUnits: "userSpaceOnUse",
    x1: 80.8067,
    x2: 405.9725,
    xlinkHref: "#a",
    y1: 426.7859,
    y2: 101.6201
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientTransform: "matrix(1.08242 0 0 -1.08242 .000094 447.028302)",
    gradientUnits: "userSpaceOnUse",
    x1: 124.1571,
    x2: 449.3229,
    xlinkHref: "#a",
    y1: 470.1364,
    y2: 144.9706
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.769531 298.667969h155.964844v68.265625h-76.800781c-4.710938 0-8.535156 3.820312-8.535156 8.535156 0 4.710938 3.824218 8.53125 8.535156 8.53125h213.332031c4.714844 0 8.535156-3.820312 8.535156-8.53125 0-4.714844-3.820312-8.535156-8.535156-8.535156h-76.796875v-68.265625h76.796875c4.714844 0 8.535156-3.820313 8.535156-8.535157 0-4.710937-3.820312-8.535156-8.535156-8.535156h-292.496094c-8.179687-.070312-14.757812-6.75-14.703125-14.929687v-10.667969h307.203125c4.710938 0 8.53125-3.820312 8.53125-8.535156 0-4.710938-3.820312-8.53125-8.53125-8.53125h-307.203125v-206.933594c-.054687-8.179688 6.523438-14.863281 14.703125-14.933594h371.660157c8.179687.070313 14.761718 6.753906 14.703124 14.933594v36.265625c0 4.714844 3.820313 8.535156 8.535157 8.535156 4.710937 0 8.53125-3.820312 8.53125-8.535156v-36.265625c.042969-17.601562-14.167969-31.9140625-31.769531-32h-371.660157c-17.601562.0859375-31.8124998 14.398438-31.769531 32v234.667969c-.0429688 17.597656 14.167969 31.914062 31.769531 32zm198.632813 0v68.265625h-25.601563v-68.265625zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m486.402344 93.867188h-110.933594c-14.140625 0-25.601562 11.460937-25.601562 25.597656v238.933594c0 14.140624 11.460937 25.601562 25.601562 25.601562h110.929688c14.140624 0 25.601562-11.460938 25.601562-25.601562v-238.933594c0-14.136719-11.460938-25.597656-25.597656-25.597656zm-119.46875 51.199218h128v179.199219h-128zm8.535156-34.132812h110.929688c4.714843 0 8.535156 3.820312 8.535156 8.53125v8.535156h-128v-8.535156c0-4.710938 3.820312-8.53125 8.535156-8.53125zm110.933594 256h-110.933594c-4.714844 0-8.535156-3.820313-8.535156-8.535156v-17.066407h128v17.066407c0 4.714843-3.820313 8.535156-8.53125 8.535156zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m185.234375 130.5c-3.390625-3.273438-8.792969-3.179688-12.066406.210938-3.195313 3.304687-3.195313 8.546874 0 11.855468l34.132812 34.132813c3.332031 3.332031 8.734375 3.332031 12.066407 0l68.265624-68.269531c3.273438-3.386719 3.179688-8.789063-.207031-12.0625-3.308593-3.195313-8.550781-3.195313-11.859375 0l-62.234375 62.230468zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m446.558594 215.527344-22.734375 20.480468-8.53125-7.679687c-3.441407-3.222656-8.839844-3.046875-12.0625.394531-3.222657 3.4375-3.046875 8.835938.394531 12.058594.082031.078125.164062.152344.25.226562l14.257812 12.800782c3.246094 2.917968 8.171876 2.917968 11.417969 0l28.441407-25.601563c3.5625-3.085937 3.953124-8.472656.867187-12.035156-3.082031-3.566406-8.472656-3.953125-12.035156-.871094-.085938.074219-.167969.148438-.25.226563zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m136.535156 128c0 51.839844 42.023438 93.867188 93.863282 93.867188 51.839843 0 93.867187-42.027344 93.867187-93.867188s-42.027344-93.867188-93.867187-93.867188c-51.8125.0625-93.804688 42.050782-93.863282 93.867188zm170.664063 0c0 42.414062-34.382813 76.800781-76.796875 76.800781-42.417969 0-76.800782-34.386719-76.800782-76.800781 0-42.417969 34.382813-76.800781 76.800782-76.800781 42.394531.046875 76.75 34.40625 76.796875 76.800781zm0 0",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m430.933594 179.199219c-30.632813 0-55.464844 24.832031-55.464844 55.46875 0 30.632812 24.832031 55.464843 55.464844 55.464843 30.632812 0 55.464844-24.832031 55.464844-55.464843-.035157-30.617188-24.847657-55.429688-55.464844-55.46875zm0 93.867187c-21.207032 0-38.398438-17.191406-38.398438-38.398437 0-21.210938 17.191406-38.402344 38.398438-38.402344 21.207031 0 38.398437 17.191406 38.398437 38.402344-.023437 21.195312-17.199219 38.375-38.398437 38.398437zm0 0",
    fill: "url(#g)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrongCustomerAuthentication1);
export default __webpack_public_path__ + "static/media/Strong Customer Authentication (1).2eb338291fa693db5681182725857b07.svg";
export { ForwardRef as ReactComponent };